import { c as _c } from "react/compiler-runtime";
import { ParsedUrlQuery } from 'querystring';
import { useState } from 'react';
import { useDidUpdateEffect } from 'shared/hooks/use-did-update-effect';
import { useSorter } from 'shared/route-query/hooks/use-sorter';
import { QueryKeysEnum } from '../enum/query-keys-enum';
import { getFilterQuery } from '../utils/get-filter-query';
import { getLimitQuery } from '../utils/get-limit-query';
import { getPaginationQuery } from '../utils/get-pagination-query';
import { getSortQuery } from '../utils/get-sort-query';
import { setFilterFromQuery } from '../utils/set-filter-from-query';
import { setLimitFromQuery } from '../utils/set-limit-from-query';
import { setPaginationFromQuery } from '../utils/set-pagination-from-query';
import { setSortFromQuery } from '../utils/set-sort-from-query';
import { useFilter } from './use-filter';
import { usePagination } from './use-pagination';
import { useQuery } from './use-query';
export const useFilterSortPagination = (defaultStaticFilter, isStaticUrl, defaultSort) => {
  const $ = _c(44);
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    clearPagination,
    setFirstPage
  } = usePagination(isStaticUrl);
  const {
    sort,
    setSort,
    getSortDirection,
    setNextSortDirection
  } = useSorter(isStaticUrl, defaultSort);
  let t0;
  if ($[0] !== isStaticUrl) {
    t0 = {
      isStatic: isStaticUrl
    };
    $[0] = isStaticUrl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    filter,
    setFilter
  } = useFilter(defaultStaticFilter, t0);
  const [memoizedQueryData, setMemoizedQueryData] = useState();
  let t1;
  let t2;
  if ($[2] !== defaultSort || $[3] !== defaultStaticFilter || $[4] !== filter || $[5] !== limit || $[6] !== pagination || $[7] !== sort) {
    t1 = () => {
      const newQueryData = {
        ...getPaginationQuery(pagination),
        ...getLimitQuery(limit),
        ...getSortQuery({
          sort,
          defaultSort
        })
      };
      try {
        const filterQuery = getFilterQuery({
          filter,
          defaultFilter: defaultStaticFilter
        });
        if (Object.keys(filterQuery).length !== 0) {
          newQueryData.filter = JSON.stringify(filterQuery);
        }
      } catch {}
      setMemoizedQueryData(newQueryData);
    };
    t2 = [defaultStaticFilter, filter, limit, pagination, sort, defaultSort];
    $[2] = defaultSort;
    $[3] = defaultStaticFilter;
    $[4] = filter;
    $[5] = limit;
    $[6] = pagination;
    $[7] = sort;
    $[8] = t1;
    $[9] = t2;
  } else {
    t1 = $[8];
    t2 = $[9];
  }
  useDidUpdateEffect(t1, t2);
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Object.values(QueryKeysEnum);
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== defaultSort || $[12] !== defaultStaticFilter || $[13] !== setFilter || $[14] !== setLimit || $[15] !== setPagination || $[16] !== setSort) {
    t4 = query => {
      const limit_0 = setLimitFromQuery(query);
      setLimit(limit_0);
      const pagination_0 = setPaginationFromQuery(query);
      setPagination(pagination_0);
      setSort(setSortFromQuery(query, defaultSort));
      const filter_0 = setFilterFromQuery(query);
      if (filter_0) {
        try {
          const newFilter = {
            ...defaultStaticFilter,
            ...JSON.parse(filter_0)
          };
          setFilter(newFilter);
        } catch {}
      } else {
        setFilter(defaultStaticFilter);
      }
    };
    $[11] = defaultSort;
    $[12] = defaultStaticFilter;
    $[13] = setFilter;
    $[14] = setLimit;
    $[15] = setPagination;
    $[16] = setSort;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== isStaticUrl || $[19] !== memoizedQueryData || $[20] !== t4) {
    t5 = {
      data: memoizedQueryData,
      skip: isStaticUrl,
      keys: t3,
      onChange: t4
    };
    $[18] = isStaticUrl;
    $[19] = memoizedQueryData;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  useQuery(t5);
  let t6;
  if ($[22] !== setFirstPage || $[23] !== setNextSortDirection) {
    t6 = field => {
      setNextSortDirection(field);
      setFirstPage();
    };
    $[22] = setFirstPage;
    $[23] = setNextSortDirection;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  const setNextSortDirectionWithPagination = t6;
  let t7;
  if ($[25] !== getSortDirection || $[26] !== setNextSortDirectionWithPagination || $[27] !== setSort || $[28] !== sort) {
    t7 = {
      sort,
      setSort,
      getSortDirection,
      setNextSortDirection: setNextSortDirectionWithPagination
    };
    $[25] = getSortDirection;
    $[26] = setNextSortDirectionWithPagination;
    $[27] = setSort;
    $[28] = sort;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== clearPagination || $[31] !== limit || $[32] !== pagination || $[33] !== setFirstPage || $[34] !== setLimit || $[35] !== setPagination) {
    t8 = {
      limit,
      setLimit,
      pagination,
      setPagination,
      clearPagination,
      setFirstPage
    };
    $[30] = clearPagination;
    $[31] = limit;
    $[32] = pagination;
    $[33] = setFirstPage;
    $[34] = setLimit;
    $[35] = setPagination;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  let t9;
  if ($[37] !== filter || $[38] !== setFilter) {
    t9 = {
      filter,
      setFilter
    };
    $[37] = filter;
    $[38] = setFilter;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t10 = {
      sorter: t7,
      paginator: t8,
      filterer: t9
    };
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  return t10;
};